import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstanceAuth } from "../../../../Utils/AxiosInstance";
import { revertAll } from "../../ResetStateAction";

const initialState = {
  AllSubscriptionsData: [],
  SingleSubscription: [],
  Transactions: [],
  Modules: [],
  PaymentData: [],
  isSuccess: false,
  message: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  IsLogin: true,
};

export const fetchSubscriptionsData = createAsyncThunk("/Subscription/GetAllSubscriptionPlans", async () => {
  const response = await axiosInstanceAuth.get(`/Subscription/GetAllSubscriptionPlans`);
  return response.data;
});
export const fetchSubscriptionsDatabyModule = createAsyncThunk(
  "/Subscription/fetchSubscriptionsDatabyModule",
  async moduleid => {
    const response = await axiosInstanceAuth.get(`/Subscription/GetAllSubscriptionPlans?moduleid=${moduleid}`);
    return response.data;
  }
);
export const fetchSingleSubscription = createAsyncThunk(`/Subscription/GetSubscriptionPlanById`, async id => {
  const response = await axiosInstanceAuth.get(`/Subscription/GetSubscriptionPlanById/${id}`);
  return response.data;
});

export const fetchTransactions = createAsyncThunk(`/Subscription/GetAllPayments`, async () => {
  const response = await axiosInstanceAuth.get(`/Subscription/GetAllPayments`);
  return response.data;
});

export const fetchModules = createAsyncThunk(`/Subscription/GetModule`, async () => {
  const response = await axiosInstanceAuth.get(`/Subscription/GetModule`);
  return response.data;
});

export const paymentPopulate = createAsyncThunk(`/Subscription/GetBusinessSubscriptionPopulate`, async () => {
  const response = await axiosInstanceAuth.get(`/Subscription/GetBusinessSubscriptionPopulate`);
  return response.data;
});

const SubscriptionSlice = createSlice({
  name: "SubscriptionSlice",
  initialState,
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchSubscriptionsData.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchSubscriptionsData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.AllSubscriptionsData = action.payload.data;
      })
      .addCase(fetchSubscriptionsData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        state.AllSubscriptionsData = [];
      })
      .addCase(fetchSingleSubscription.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchSingleSubscription.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.SingleSubscription = action.payload.data;
      })
      .addCase(fetchSingleSubscription.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        state.SingleSubscription = [];
      })
      .addCase(fetchTransactions.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.Transactions = action.payload;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        state.Transactions = [];
      })
      .addCase(fetchModules.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchModules.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.Modules = action.payload;
      })
      .addCase(fetchModules.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        state.Modules = [];
      })
      .addCase(paymentPopulate.pending, state => {
        state.status = "loading";
      })
      .addCase(paymentPopulate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.PaymentData = action.payload.data;
      })
      .addCase(paymentPopulate.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        state.PaymentData = [];
      });
  },
});

export const getSubscriptions = state => state.Subscription;
export default SubscriptionSlice.reducer;
